import { openLink } from '../../../../functions/functions';
import './periodTitle.sass';

/**
 * Componente de encabezado para tarjetas de eventos deportivos
 * Muestra el estado del evento (próximo, en vivo, finalizado) y botón de apuestas
 * Se adapta automáticamente según el tipo de deporte (general vs tenis)
 * 
 * @param {Object} props - Propiedades del componente
 * @param {string} props.clase - Clase CSS que indica el estado del evento
 * @param {string} props.opta_event_url - URL para estadísticas del evento
 * @param {string} props.period_title - Título del período/estado del evento
 * @param {string} props.time_format - Hora formateada del evento
 * @param {boolean} props.isTenis - Indica si es un evento de tenis
 * @param {string} props.tenis_fase - Fase del torneo de tenis (cuartos, semifinal, etc.)
 * @param {boolean} props.mostrarBotonApostarCard - Controla la visibilidad del botón de apuestas
 * @param {boolean} props.isStrendus - Determina el estilo del botón según la casa de apuestas
 * @param {string} props.apostarHref - URL para el botón de apuestas
 * 
 * @returns {JSX.Element} Encabezado con estado del evento y botón de apuestas
 */
export default function PeriodTitle({
  clase = "",
  opta_event_url = "",
  period_title = "",
  utc_date,
  time_format = "",
  isTenis,
  tenis_fase = ""
}) {

  const cls = String(clase).toLowerCase().trim();
  const fase = String(tenis_fase || "").toUpperCase();

  const getLocalTime = (utcDate) => {
    if (!utcDate) return time_format;
    const date = new Date(utcDate);
    return date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  const getStateConfig = () => {
    switch (cls) {
      case "clarosports-next-game":
        const displayTime = getLocalTime(utc_date);
        return {
          className: "card-header-left-next",
          text: isTenis ? `${displayTime} hrs - ${fase}` : `${displayTime} hrs`
        };
      default:
        return {
          className: "",
          text: ""
        };
    }
  };

  const { className, text } = getStateConfig();

  return (
    <div
      className={`card-header ${clase} ${isTenis ? ' cursorAuto' : ''}`}
      onClick={() => openLink(opta_event_url, true)}
      role="button"
      tabIndex={0}
      aria-label={`Ver estadísticas del evento ${period_title}`}
    >
      <div className="card-header-left">
        <p className={className}>{text}</p>
      </div>
    </div>
  );
}